import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { getHeaders } from '../tramite.service';

@Component({
  selector: 'app-list-tramites',
  templateUrl: './list-tramites.component.html',
  styleUrls: ['./list-tramites.component.scss']
})
export class ListTramitesComponent implements OnInit {
  displayedColumns: string[] = ['nombre', 'codigo', 'categoria', 'area', 'tiempoRespuesta', 'status', 'acciones'];
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<any>();

  tramites: any[] = [];
  filteredTramites: any[] = [];
  searchValue: string = '';
  selectedCategory: string = '';
  selectedStatus: string = '';
  isLoading: boolean = false;

  private baseUrl = environment.API_URL;

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    public router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadTramites();
  }

  loadTramites(): void {
    this.isLoading = true;
    const headers = getHeaders();
    
    this.http.get<any[]>(`${this.baseUrl}/miveracruz/forms`, { headers })
      .subscribe(
        (data: any[]) => {
          this.tramites = data;
          this.filteredTramites = data;
          this.dataSource = new MatTableDataSource(this.filteredTramites);
          this.dataSource.sort = this.sort;
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        (error) => {
          console.error('Error al cargar los trámites:', error);
          this.sendNotification('Error', 'No se pudieron cargar los trámites', 'error');
          this.isLoading = false;
        }
      );
  }

  applyFilters(): void {
    let filtered = [...this.tramites];

    // Filtro por búsqueda
    if (this.searchValue) {
      filtered = filtered.filter(item => 
        item.Form?.FormsCommon?.Name?.toLowerCase().includes(this.searchValue.toLowerCase()) ||
        item.Form?.FormsCommon?.Code?.toLowerCase().includes(this.searchValue.toLowerCase())
      );
    }

    // Filtro por categoría
    if (this.selectedCategory) {
      filtered = filtered.filter(item => 
        item.Category?.Name === this.selectedCategory
      );
    }

    // Filtro por estado
    if (this.selectedStatus) {
      if (this.selectedStatus === 'Activos') {
        filtered = filtered.filter(item => item.Form?.Active === true);
      } else if (this.selectedStatus === 'Inactivos') {
        filtered = filtered.filter(item => item.Form?.Active === false);
      }
    }

    this.filteredTramites = filtered;
    this.dataSource = new MatTableDataSource(this.filteredTramites);
    this.dataSource.sort = this.sort;
  }

  onSearchChange(): void {
    this.applyFilters();
  }

  onCategoryChange(): void {
    this.applyFilters();
  }

  onStatusChange(): void {
    this.applyFilters();
  }

  editTramite(tramite: any): void {
    this.router.navigate(['/catalogs/edit-tramite', tramite.Form.id]);
  }

  deleteTramite(tramite: any): void {
    if (confirm(`¿Está seguro de que desea eliminar el trámite "${tramite.Form?.FormsCommon?.Name}"?`)) {
      const headers = getHeaders();
      
      this.http.put(`${this.baseUrl}/miveracruz/forms`, {
        id: tramite.Form.id,
        Active: false,
        updated_by: this.getCurrentUserId()
      }, { headers })
        .subscribe(
          (response) => {
            this.sendNotification('Éxito', 'Trámite eliminado correctamente', 'success');
            this.loadTramites();
          },
          (error) => {
            console.error('Error al eliminar el trámite:', error);
            this.sendNotification('Error', 'No se pudo eliminar el trámite', 'error');
          }
        );
    }
  }

  getCurrentUserId(): string {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const user = JSON.parse(currentUser);
      return user.id || '';
    }
    return '';
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-MX');
  }

  formatTime(time: number, type: string): string {
    if (!time) return '-';
    return `${time} ${type}`;
  }

  sortData(sort: Sort): void {
    if (!sort.active || sort.direction === '') {
      return;
    }

    const data = this.filteredTramites.slice();
    this.filteredTramites = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'nombre':
          return this.compare(a.Form?.FormsCommon?.Name, b.Form?.FormsCommon?.Name, isAsc);
        case 'codigo':
          return this.compare(a.Form?.FormsCommon?.Code, b.Form?.FormsCommon?.Code, isAsc);
        case 'categoria':
          return this.compare(a.Category?.Name, b.Category?.Name, isAsc);
        case 'tiempoRespuesta':
          return this.compare(
            a.Form?.FormsCommon?.AnswerTime, 
            b.Form?.FormsCommon?.AnswerTime, 
            isAsc
          );
        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource(this.filteredTramites);
  }

  compare(a: any, b: any, isAsc: boolean): number {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sendNotification(title: string = 'Mi Veracruz', message: string, type: string): void {
    this.toastr[type](message, title, { timeOut: 3500 });
  }
}

